<div class="grid-x grid-margin-x">

  <div class="cell">
    <label>Send via Certified Mail:</label>
  </div>

  <div class="cell small-6">
    <label class="cursor-pointer">
      <input type="checkbox" name="mailType" [(ngModel)]="conf.sendCertified" />
      <span>Certified</span>
    </label>
  </div>

  <div class="cell small-12">
    <label>
      Title Rule:
      <input type="text" [(ngModel)]="conf.title" />
    </label>
  </div>

  <div class="cell small-12">
    <label>
      Organization Rule:
      <input type="text" [(ngModel)]="conf.organizationIdRule" />
    </label>
  </div>

  <div class="cell small-12">
    <label>
      Application Number Rule:
      <input type="text" [(ngModel)]="conf.applicationNumberRule" />
    </label>
  </div>


  <div class="cell small-12">
    <label>
      Rendered Document Id Context Target Path:
      <input type="text" [(ngModel)]="conf.documentIdPath" />
    </label>
  </div>

  @if (offices) {
    <div class="cell small-12">
      <label>
        ODNR Office:
        <select #selector name="selUserSideEffect" [(ngModel)]="conf.office">
          @for (option of offices | async; track option) {
            <option [ngValue]="option">{{option.title}}</option>
          }
        </select>
      </label>
    </div>
  }

  <div class="cell small-12">
    <onbase-configuration [providedOnBaseDocumentGroupName]="conf.onBaseDocumentGroupName" [providedOnBaseDocumentTypeName]="conf.onBaseDocumentTypeName"
      (selectedDocumentGroup)="onDocumentGroupChanged($event)" (selectedDocumentType)="onDocumentTypeChanged($event)"
      (relevantKeywords)="onKeywordsChanged($event)">

    </onbase-configuration>
  </div>

  <div class ="cell small-12">
    <label>
      Onbase File Name:
      <input type="text" [(ngModel)]="conf.onBaseFileName" />
    </label>
  </div>

  <div class ="cell small-12">
    <label>
      Temporary Document Type:
      <select [(ngModel)] ="conf.documentType">
        @for (option of documentTypes | async; track option) {
          <option  [ngValue]="option">
          {{option.displayName}}</option>
        }
      </select>
    </label>
  </div>

  <div class="cell small-12">
    <label>
      Recipient Name1 Rule:
      <input type="text" [(ngModel)]="conf.recipient.name1" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Recipient Name2 Rule:
      <input type="text" [(ngModel)]="conf.recipient.name2" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Recipient Name3 Rule:
      <input type="text" [(ngModel)]="conf.recipient.name3" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Recipient Address1 Rule:
      <input type="text" [(ngModel)]="conf.recipient.address1" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Recipient Address2 Rule:
      <input type="text" [(ngModel)]="conf.recipient.address2" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Recipient Address3 Rule:
      <input type="text" [(ngModel)]="conf.recipient.address3" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Recipient City Rule:
      <input type="text" [(ngModel)]="conf.recipient.city" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Recipient State Rule:
      <input type="text" [(ngModel)]="conf.recipient.state" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Recipient ZipCode Rule:
      <input type="text" [(ngModel)]="conf.recipient.zipCode" />
    </label>
  </div>
  <div class="cell small-12">
    <label>
      Recipient ZipPlus4 Rule:
      <input type="text" [(ngModel)]="conf.recipient.zipPlus4" />
    </label>
  </div>
  <div class="cell small-12">
    <h4>Letter Template Configuration</h4>
  </div>
  <div class="cell small-12">
    <textarea [(ngModel)]="conf.template.content" #templateContent="ngModel" (blur)="templateContentChanged(templateContent)" (keyup.enter)="templateContentChanged(templateContent)">

    </textarea>
  </div>
  @for (tr of conf.template.transforms; track tr) {
    <div class="cell small-12">
      <label>{{tr.name}} <input type="text" [(ngModel)]="tr.expression" /></label>
    </div>
    <div class="cell large-12">
      <label>{{tr.name}} - Relevant OnBase Keyword</label>
      <ng-select [(ngModel)]="tr.onBaseKeywordName" [items]="onBaseKeywords" bindLabel="name" bindValue="name" placeholder=""></ng-select>
    </div>
  }
  <!-- <input type="text" id="subject" name="subject" (keyup.enter)="subjectChanged(subject)" (blur)="subjectChanged(subject)" required [(ngModel)]="notification.subject.template" #subject="ngModel" /> -->
</div>
